module.exports = __webpack_public_path__ + "img/de.be91dc7b.svg";